import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";

@Module({
    name: "MenusStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class MenusStore extends VuexModule {
    // state
    private _apiResponse: CMS.Menu[] = [];
    private _menuById: { [menuId: number]: CMS.Menu } = {};

    // getter
    get all() {
        return this._apiResponse || [];
    }

    get menuById() {
        return this._menuById || {};
    }

    @Action
    public async init() {
        const response: CMS.Menu[] = await CmsApiClient.getMenus();
        this.refresh(response);
    }

    @Action
    private refresh(response: CMS.Menu[]) {
        this.initVals();
        this.setResponse(response);
        for (let i = 0; i < response.length; i++) {
            this.setMenuById(response[i]);
        }
    }

    @Mutation
    private initVals() {
        this._apiResponse = [];
        this._menuById = {};
    }

    @Mutation
    private setResponse(response: CMS.Menu[]) {
        this._apiResponse = response;
    }

    @Mutation
    private setMenuById(menu: CMS.Menu) {
        Vue.set(this._menuById, menu.id, menu);
    }

    @Action
    public async create(menu: CMS.Menu) {
        const added = this._apiResponse.concat([menu]);
        this.refresh(added);
        await CmsApiClient.createMenu(menu);
        await this.init();
    }

    @Action
    public async edit(menu: CMS.Menu) {
        const edited = this._apiResponse.map(v => (v.id == menu.id) ? menu : v);
        this.refresh(edited);
        await CmsApiClient.editMenu(menu);
        this.init();
    }

    @Action
    public async localSort(order: number[]) {
        const sorted: CMS.Menu[] = order.map(id => this._menuById[id]);
        this.refresh(sorted);
    }

    @Action
    public async applySort() {
        const sortedIds: number[] = this._apiResponse.map(v => v.id);
        await CmsApiClient.sortMenus(sortedIds);
        this.init();
    }

    @Action
    public async delete(menuId: number) {
        const target = this.menuById[menuId];
        const deleted = this._apiResponse.filter(v => v.id != menuId);
        this.refresh(deleted);
        await CmsApiClient.deleteMenu(target);
        this.init();
    }


    @Action
    public async addMenuStore(param: {menu: CMS.Menu, storeId: number}) {
        const added = this._apiResponse.map(v => (v.id == param.menu.id) ? param.menu : v);
        this.refresh(added);
        await CmsApiClient.createMenuStore(param.menu, param.storeId);
        this.init();
    }

    @Action
    public async deleteMenuStore(param: {menu: CMS.Menu, storeId: number}) {
        const deleted = this._apiResponse.map(v => (v.id == param.menu.id) ? param.menu : v);
        this.refresh(deleted);
        await CmsApiClient.deleteMenuStore(param.menu, param.storeId);
        this.init();
    }

    @Action
    public async editMenuStores(menu: CMS.Menu) {
        const edited = this._apiResponse.map(v => (v.id == menu.id) ? menu : v);
        this.refresh(edited);
        await CmsApiClient.updateMenuStores(menu);
    }
}

export default getModule(MenusStore);
